import React from 'react';
import cx from 'classnames';
import { track } from '@trello/analytics';
import { useUpdateCardCoverMutation } from '@trello/graphql/generated';
import { forTemplate } from 'app/common/lib/util/i18n';

import styles from './ColorCover.less';

const format = forTemplate('card_cover_chooser');

interface ColorCoverProps {
  cardId: string;
  selectedColor?: string | null;
}

export const cardCoverColors = [
  'blue',
  'green',
  'orange',
  'red',
  'purple',
  'yellow',
];

export const ColorCover: React.FunctionComponent<ColorCoverProps> = ({
  cardId,
  selectedColor,
}) => {
  const [updateCardCover] = useUpdateCardCoverMutation();

  const setCover = async (color: string) => {
    let cover: null | {
      color: string;
      brightness: string;
    } = {
      color,
      brightness: 'light',
    };

    if (color === selectedColor) {
      cover = null;
      track('Card Cover Chooser', 'Toggled Cover Off', 'Color');
    } else {
      track('Card Cover Chooser', 'Chose Cover', 'Color');
    }

    await updateCardCover({
      variables: {
        cardId,
        cover,
      },
    });
  };

  return (
    <>
      <h4 className={styles.heading}>{format('colors')}</h4>
      <div className={styles.colorTiles}>
        {cardCoverColors.map((color) => (
          <button
            key={color}
            onClick={() => setCover(color)}
            className={cx(styles.colorTile, styles[color], {
              [styles.selected]: color === selectedColor,
            })}
          />
        ))}
      </div>
    </>
  );
};
